import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BloodBankGenApi } from '../api/bloodbankgen.api';
import { switchMap, map } from 'rxjs/operators';

import { BloodBankGenData, BloodBankGen } from '../../../interfaces/masters/bloodbankgen' ;
@Injectable()
export class BloodBankGenService extends BloodBankGenData {

    constructor(private api: BloodBankGenApi) {
      super();
    }
  
  
    list(url: string): Observable<BloodBankGen[]> {
      
      return this.api.list(url);
    }
  
    getById(url:string): Observable<BloodBankGen>{
        return this.api.getById(url);
    }
  
    create(url: string, data:BloodBankGen): Observable<BloodBankGen[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:BloodBankGen): Observable<BloodBankGen> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  